import { axiosApi } from "@/common/js/api"
import { dealReturn } from '@/common/js'
const province_api = {
  title: "省",
  url: "areas",
  method: "post"
}
const area_api = {
  title: "地区",
  url: "getarea",
  method: "get",
}

export const province = {
  data() {
    return {
      provinceList: [],
      provinceListLoading: false
    };
  },
  created() {
    this.getProvinceList();
  },
  methods: {
    async getProvinceList() {
      this.provinceListLoading = true;
      let { data, err } = await axiosApi(province_api);
      this.provinceListLoading = false;
      if (data && data.data && data.data.data) {
        // console.log("data", data)
        this.provinceList = data.data.data;
      }
      dealReturn(data, err);
    }
  }
}

export const city = {
  data() {
    return {
      cityList: [],
      cityListLoading: false
    };
  },

  methods: {
    async getCityList(area_id) {
      // let area_id = this.form.receiverState
      // let area_id = this.form.State
      // 省市县 字段不统一  完了
      this.cityListLoading = true;
      let { data, err } = await axiosApi({
        url: `${area_api.url}/${area_id}`,
        method: area_api.method
      });
      this.cityListLoading = false;

      if (data && data.data && data.data.data) {
        this.cityList = data.data.data;
      }
      dealReturn(data, err);
    },
    provinceChange() {
      // console.log("provinceChange this.form.rcvState", this.form.rcvState)
      if (!this.form.rcvState) return;
      this.getCityList(this.form.rcvState);
      this.form.rcvCity = "";
      this.form.rcvDistrict = ""
      this.form.rcvTown = ""
    },
  },
  // 编辑中的数据 this.form.rcvState是中文，没有area_id 没法搜
  // watch: {
  //   'form.rcvState': {
  //     handler: function () {
  //       if (this.form.rcvState) {
  //         this.getCityList(this.form.rcvState);
  //       }
  //     }
  //   }
  // }
}
// 区、县
export const district = {
  data() {
    return {
      districtList: [],
      districtListLoading: false
    };
  },

  methods: {
    async getDistrictList(area_id) {
      this.districtListLoading = true;
      let { data, err } = await axiosApi({
        url: `${area_api.url}/${area_id}`,
        method: area_api.method
      });
      this.districtListLoading = false;
      if (data && data.data && data.data.data) {
        this.districtList = data.data.data;
      }
      dealReturn(data, err);
    },

    cityChange() {
      // console.log("cityChange this.form.rcvCity", this.form.rcvCity)
      if (!this.form.rcvCity) return;
      this.getDistrictList(this.form.rcvCity);
      this.form.rcvDistrict = ""
      this.form.rcvTown = ""
    },
  },
  // watch: {
  //   'form.rcvCity': {
  //     handler: function () {
  //       if (this.form.rcvCity) {
  //         this.getCityList(this.form.rcvCity);
  //       }
  //     }
  //   }
  // }
}
// 镇
export const town = {
  data() {
    return {
      townList: [],
      townListLoading: false
    };
  },

  methods: {
    async getTownList(area_id) {
      this.townListLoading = true;
      let { data, err } = await axiosApi({
        url: `${area_api.url}/${area_id}`,
        method: area_api.method
      });
      this.townListLoading = false;
      if (data && data.data && data.data.data) {
        this.townList = data.data.data;
      }
      dealReturn(data, err);
    },

    districtChange() {
      // console.log("districtChange ", this.form.rcvDistrict)
      if (!this.form.rcvDistrict) return;
      this.getTownList(this.form.rcvDistrict);
      this.form.rcvTown = ""
    },
  },
  // watch: {
  //   'form.rcvDistrict': {
  //     handler: function () {
  //       if (this.form.rcvDistrict) {
  //         this.getCityList(this.form.rcvDistrict);
  //       }
  //     }
  //   }
  // }
}


// WEBPACK FOOTER //
// ./src/common/mixins/area-select/index.js